import Cookies from 'js-cookie'
import {$app} from '../app'
import PushNotification from '../app/pushNotification'

export function getApiAuthToken () {
	try {
		return localStorage.getItem("APIAuthToken")
	} catch (e) {
		return null
	}
}

export function setApiAuthToken (token) {
	localStorage.setItem("APIAuthToken", token)
}

export function removeApiAuthToken () {
	localStorage.removeItem("APIAuthToken")
}

export async function whereIsTheStateIn () {
	const local_token = getApiAuthToken()
	let {token, is_authorized} = await $app.$api({action: 'touch'})

	// Retrieve push notification token
	new PushNotification()


	// Not logged in, but localStorage token is set
	if(token === null && is_authorized === false && (local_token !== null && local_token !== "null")) {

		await $app.$api({
			action: 'set-token',
			method: "POST",
			data: {
				token: local_token
			}
		})

		const res2 = await $app.$api({action: 'touch'})

		token = res2.token
		is_authorized = res2.is_authorized

	}


	return {isAuthorized: is_authorized}

}

export async function authenticate (mail, password) {

	await $app.$api({
		action: "login",
		method: "POST",
		data: {
			mail,
			password
		}
	}).then(async (res) => {
		if (res.hasOwnProperty('was_successfull') && res.was_successfull === false) {
			$app.handleError(res)
			//this.inputPassword.current.value = ""
			//this.inputEmail.current.focus()
			//throw new Error(res)
		}

		return res

	}).catch(e => {

		$app.handleError(e)

	})
}


export const UTM_COOKIE_NAME = 'utm_params'
const UTM_COOKIE_VALIDITY = 14 // days

export function createUTM () {

	if(Cookies.get(UTM_COOKIE_NAME)) return

	const url = new URL(window.location)
	const { searchParams } = url

	const has_params = (searchParams.has('utm_campaign') && searchParams.has('utm_medium') && searchParams.has('utm_source'))

	if(has_params) {

		Cookies.set(UTM_COOKIE_NAME, JSON.stringify({
			utm_campaign: searchParams.get('utm_campaign'),
			utm_medium: searchParams.get('utm_medium'),
			utm_source: searchParams.get('utm_source')
		}), {
			expires: UTM_COOKIE_VALIDITY
		})

	}

}

export function getQueryParameter (key) {
	const url = new URL(window.location)
	const { searchParams } = url

	return searchParams.get(key) ?? null

}

export function createAnalytics (GID, dataLayer = "dataLayer") {

	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!=='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script',dataLayer,GID)


}

export function pushAnalytics (data, dataLayer = "dataLayer") {

	window[dataLayer] = (window[dataLayer] || [])
	window[dataLayer].push(data)

}

export const SSID_COOKIE_NAME = 'store_system_id'
const SSID_COOKIE_VALIDITY = 30 // days

export function createSSID () {

	const url = new URL(window.location)
	const { searchParams } = url

	if(searchParams.has('storeid')) {

		Cookies.set(SSID_COOKIE_NAME, searchParams.get('storeid'), {
			expires: SSID_COOKIE_VALIDITY
		})

	}

}
